import { queryString } from '@shared/hooks/recoil-query';
import { api_ } from '@shared/plugIn/axios';
import { LowerRole } from '@shared/types';

import {
  BugoBrand,
  BugoBrandCreate,
  BugoBrandUpdate,
  UserBugoBrand,
} from './bugoBrand.interface';

export const getBugoBrandById = async (bugoBrandId: string) => {
  const { data: bugoBrand } = await api_.get<UserBugoBrand>(
    `/public/bugo-brand/${bugoBrandId}?${queryString({
      populate: [
        {
          path: 'bugoAgency.headerImage',
        },
        {
          path: 'bugoAgency.footerImage',
        },
        {
          path: 'bugoAgencyList.headerImage',
        },
        {
          path: 'bugoAgencyList.footerImage',
        },
      ],
    })}`,
  );

  return bugoBrand;
};

export const createBugoBrand = async (
  bugoBrandCreate: BugoBrandCreate,
  bugoRole: LowerRole,
) => {
  const { data: bugoBrand_ } = await api_.post<BugoBrand>(
    `/${bugoRole}/bugo-brand`,
    bugoBrandCreate,
  );
  return bugoBrand_;
};

/**
 * 상조의 테스트 상가(부고) id를 확보한다. (관리자 전용)
 * 지정돼 있으면 그 id, 없으면 서버가 테스트 상가(fevent·member·bugo)를 만들어 지정한 뒤 돌려준다.
 * 구서버(엔드포인트 없음=404)면 null — 호출부는 보기 전용 미리보기로 폴백한다.
 */
export const ensureBugoBrandGiftTestBugo = async (
  bugoBrandId: string,
): Promise<string | null> => {
  try {
    const { data } = await api_.post<{ bugoId?: string }>(
      `/admin/bugo-brand/${bugoBrandId}/gift-test-bugo`,
    );
    return data?.bugoId ?? null;
  } catch (error: any) {
    if (error?.response?.status === 404) return null;
    throw error;
  }
};

export const updateBugoBrand = async (
  bugoBrandUpdate: BugoBrandUpdate,
  bugoRole: LowerRole,
) => {
  const { data: bugoBrand } = await api_.patch(
    `/${bugoRole}/bugo-brand/${bugoBrandUpdate._id}`,
    bugoBrandUpdate,
  );
  return bugoBrand;
};
